module.exports = __webpack_public_path__ + "img/mastercard.22ed8e6f.svg";